import icons from "../assets";

export const chemicalsCards = [
  {
    id: 0,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728843412/user-images/user-1728843410860.jpg",
    stateAppereance: "Powder & Liquid",
    sectorSection: "Well Cementing Additives",
    cardTitle: "SYNTHETIC FLUID LOSS AND GAS MIGRATION CONTROL ADDITIVE",
  },
  {
    id: 1,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728846973/user-images/user-1728846972039.jpg",

    stateAppereance: "White powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "FLUID LOSS AND GAS MIGRATION CONTROL ADDITIVE",
  },
  {
    id: 2,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728843974/user-images/user-1728843973464.jpg",

    stateAppereance: "White to cream-colored powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "FLUID LOSS CONTROL VISCOSIFIER",
  },
  {
    id: 3,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728849393/user-images/user-1728849392288.jpg",

    stateAppereance: "Brown to black powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "SYNTHETIC FLUID LOSS AND GAS MIGRATION CONTROL ADDITIVE",
  },
  {
    id: 4,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728844571/user-images/user-1728844570125.jpg",

    stateAppereance: "Yellow to brown powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "RETARDER LR - LIGNOSULFONATE RETARDER FOR LOW TEMPERATURES",
  },
  {
    id: 5,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728844943/user-images/user-1728844941845.jpg",

    stateAppereance: "beige powder.",
    sectorSection: "Well Cementing Additives",
    cardTitle: "ORGANIC RETARDER FOR MODERATE TEMPERATURES",
  },
  {
    id: 6,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728845166/user-images/user-1728845165704.jpg",

    stateAppereance: "Light cream-colored powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "HIGHLY EFFECTIVE LOW-DOSAGE DISPERSANT",
  },
  {
    id: 7,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728845515/user-images/user-1728845514267.jpg",

    stateAppereance: "Red powder",
    sectorSection: "Well Cementing Additives",
    cardTitle: "DISPERSANT RHEOLOGY MODIFIER",
  },
  {
    id: 8,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848482/user-images/user-1728848481700.webp",

    stateAppereance: "Clear colorless liquid",
    sectorSection: "Speciality Chemicals",
    cardTitle: "XYLENE",
  },
  {
    id: 9,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848614/user-images/user-1728848613101.png",

    stateAppereance: "Clear colorless liquid",
    sectorSection: "Speciality Chemicals",
    cardTitle: "TOLUENE",
  },
  {
    id: 9,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848716/user-images/user-1728848715130.jpg",

    stateAppereance: "White powder, crystals, or chunks",
    sectorSection: "Speciality Chemicals",
    cardTitle: "CESIUM FORMATE",
  },
  {
    id: 10,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848787/user-images/user-1728848786785.webp",

    stateAppereance: " Colorless or white crystalline solids",
    sectorSection: "Speciality Chemicals",
    cardTitle: "ZINC HALIDE",
  },
  {
    id: 11,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728741179/user-images/user-1728741178259.jpg",

    stateAppereance: "Dark brown to black powder or granules",
    sectorSection: "Fracking Chemicals",
    cardTitle: "SULPHONATED ASPHALT",
  },
  {
    id: 12,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848717/user-images/user-1728848717313.jpg",

    stateAppereance: "clear to slightly opaque liquid, or powder",
    sectorSection: "Fracking Chemicals",
    cardTitle: "DRILLING MUD DETERGENT",
  },
  {
    id: 13,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848908/user-images/user-1728848906884.jpg",

    stateAppereance:
      "liquid, powder, or gel depending on the type and formulation",
    sectorSection: "Fracking Chemicals",
    cardTitle: "SURFACTANT",
  },
  {
    id: 13,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728821712/user-images/user-1728821711249.webp",

    stateAppereance: "Liquid",
    sectorSection: "Crude Additives",
    cardTitle: "CORROSION INHIBITOR",
  },
  {
    id: 14,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728851520/user-images/user-1728851519873.jpg",

    stateAppereance: "Viscouse Liqid",
    sectorSection: "Crude Additives",
    cardTitle: "DEMULSIFIER",
  },
];

export const serviceCard = [
  {
    id: 1,
    name: "Oil & Gas",
    cardlinkTitle: "oilandgas",
    description:"Suvira Energy, headquartered in the dynamic metropolis of Mumbai, stands as a pioneering force in the realm of technology-driven solutions for the Energy sector in India. Renowned for our prowess in cutting-edge Project Management, Sales &amp; Marketing, and Services, we consistently cater to the diverse needs of our esteemed clientele.",
    backgroundImage: icons.oilGasImage,
    pdf: "old-file.pdf", 
    subsectors: [
      {
        linkTile: "Exploration & Production",
        href: `/offerings/oilandgas/ExplorationProduction`,
      },
      {
        linkTile: "Drilling Services",
        href: "/offerings/DrillingService",
      },
      {
        linkTile: "IoT / IT / Big Data Analysis",
        href: "/offerings/IOT-IT-BigDataAnalysis",
      },
      {
        linkTile: "Water Treatment & Filtration",
        href: "/offerings/WaterTreatmentFiltration",
      },
      {
        linkTile: "Pipeline Division",
        href: "/offerings/PipelineDivision",
      },
    ],
  },
  {
    id: 2,
    name: "Down Stream",
    cardlinkTitle: "downStream",
    backgroundImage: icons.chemicalImage,
    description:"Suvira Energy, headquartered in the dynamic metropolis of Mumbai, stands as a pioneering force in the realm of technology-driven solutions for the Energy sector in India. Renowned for our prowess in cutting-edge Project Management, Sales &amp; Marketing, and Services, we consistently cater to the diverse needs of our esteemed clientele.",
    pdf: "old-file.pdf", 
    subsectors: [
      {
        linkTile: "Chemicals",
        href: "/offerings/Chemicals",
      },
    ],
  },
  {
    id: 3,
    name: "Renewable",
    cardlinkTitle: "renewable",
    backgroundImage: icons.renewableEnergy,
    description:"Suvira Energy, headquartered in the dynamic metropolis of Mumbai, stands as a pioneering force in the realm of technology-driven solutions for the Energy sector in India. Renowned for our prowess in cutting-edge Project Management, Sales &amp; Marketing, and Services, we consistently cater to the diverse needs of our esteemed clientele.",
    pdf: "old-file.pdf", 
    subsectors: [
      {
        linkTile: "Renewable Energy",
        href: "/services/renewable",
      },
    ],
  },
];

export const renewableCards = [
  {
    id: 0,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728883632/user-images/user-1728883631267.jpg",
    stateAppereance: "NA",
    sectorSection: "Well Cementing Additives",
    cardTitle: "Unigreen",
  },
  {
    id: 1,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728848908/user-images/user-1728848906884.jpg",

    stateAppereance:
      "liquid, powder, or gel depending on the type and formulation",
    sectorSection: "Well Cementing Additives",
    cardTitle: "SURFACTANT",
  },
];
export const oilandGasCards = [
  {
    id: 0,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728883632/user-images/user-1728883631267.jpg",
    stateAppereance: "NA",
    sectorSection: "Exploration & Production",
    cardTitle: "Unigreen",
  },
  {
    id: 14,
    logoSrc:
      "https://res.cloudinary.com/dvgcxl8gc/image/upload/v1728851520/user-images/user-1728851519873.jpg",

    stateAppereance: "Viscouse Liqid",
    sectorSection: "Exploration & Production",
    cardTitle: "DEMULSIFIER",
  },
];



// aboutus cards data

export const Aboutuscards = [
  {
    text: "Suvira introduced electromagnetic survey in India and helped Reliance & ONGC in some of their deep-water discoveries",
    year: "2005-2006",
    bgColor: "#05A6F0",
  },
  {
    text: "Suvira introduced mud cooler technology for the first time in India. For HT-HP wells.",
    year: "2006-2007",
    bgColor: "#81BC06",
  },
  {
    text: "Suvira pioneers the use of EV downhole camera technology in India.",
    year: "2011-2012",
    bgColor: "#81BC06",
  },
  {
    text: "Suvira becomes the first company in India to introduce Geochem survey from W.L. Gore and helped Oil India & ONGC in their exploration efforts.",
    year: "2007-2009",
    bgColor: "#05A6F0",
  },
  {
    text: "Suvira emphasizes local manufacturing and streamlining its operations, positioning itself as a major supplier of chemicals and customized solutions for oil and gas companies.",
    year: "2021-2022",
    bgColor: "#05A6F0",
  },
  {
    text: "Suvira is strategically expanding its manufacturing capabilities and diversifying its product portfolio to drive global exports of high-quality chemicals.",
    year: "2023-Present",
    bgColor: "#81BC06",
  },
];